// extracted by mini-css-extract-plugin
export var desc = "style-module--desc--ee0f4";
export var item = "style-module--item--6b9c4";
export var speaker = "style-module--speaker--6b504";
export var wrapper = "style-module--wrapper--dc533";